import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import type { PolicyColumnKey } from "@common-shared/config/oneVerify/oneVerifyPoliciesColumns.config"
import { ICoverageHistoryListSort } from "@common-shared/types/internalApis/coverageHistory.types"
import {
    IFetchedPoliciesExport,
    IPoliciesListFiltersData,
} from "@common-shared/types/policies.types"
import { IOneVerifyExportHistoryListRequestData } from "@common-shared/types/requestData/oneVerifyRequestData.types"
import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper"
import { PoliciesService } from "./policies.service"

export class PoliciesExportService {
    /**
     * Trigger export policies report to email
     */
    static async exportPoliciesListToEmail(
        practice: IPractice,
        reportType: PoliciesListType,
        filters: IPoliciesListFiltersData = {},
        sort: ICoverageHistoryListSort = {},
        neededColumns?: PolicyColumnKey[],
    ): Promise<
        | {
              triggered: boolean
          }
        | undefined
    > {
        const requestData: IOneVerifyExportHistoryListRequestData = {
            reportType,
            neededColumns,
            sort,
            filters: PoliciesService.mapPoliciesFilters(
                reportType,
                filters,
                false,
            ),
        }

        const result = await HttpHelper.sendRequest(
            API_ROUTES.COVERAGE_HISTORY_EXPORT_CREATE.replace(
                ":practiceId",
                practice.id.toString(),
            ),
            requestData,
            "POST",
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }

    /**
     * Get previously generated policies report
     */
    static async getPoliciesExport(
        practice: IPractice,
        exportFileName: string,
    ): Promise<IFetchedPoliciesExport | undefined> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.COVERAGE_HISTORY_EXPORT_GET.replace(
                ":practiceId",
                practice.id.toString(),
            ).replace(":exportFileName", exportFileName),
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }
}
